module.exports = __webpack_public_path__ + "img/318ae48.jpg";